var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"attach":".image-container","bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({class:{
        point: _vm.geometry.type === 'POINT',
        rect: _vm.geometry.type === 'RECTANGLE',
        pointer: true,
        highlighted: _vm.active,
        'elevation-3': true
      },style:({
        width: ((_vm.geometry.width) + "%"),
        height: ((_vm.geometry.height) + "%"),
        top: ((_vm.geometry.y) + "%"),
        left: ((_vm.geometry.x) + "%")
      }),attrs:{"slot":"activator"},slot:"activator"},on))]}}])},[_c('div',{staticClass:"py-2",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('v-divider',{attrs:{"dark":""}}),_c('div',{staticClass:"py-1",domProps:{"innerHTML":_vm._s(_vm.author)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }